import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import UserList from '@/components/UserList'
import NewTerminal from '@/components/NewTerminal'
import TerminalList from '@/components/TerminalList'
import TerminalActive from '@/components/TerminalActive'
import Ldh12active from '@/components/Ldh12active'
import BasestationList from '@/components/BasestationList'
import NewBasestation from '@/components/NewBasestation'
import QxaccountList from '@/components/QxaccountList'
import QxaccountDetail from '@/components/QxaccountDetail'
import VersionList from '@/components/VersionList'
import Newproduct from '@/components/NewProduct'

Vue.use(Router)


export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      meta:{
        layout:'no-sidebar',
        isLogin:false
      },
      component:Login
      
    },
    {
      path:'/home',
      name:'Home',
      meta:{
        layout:'default',
        isLogin:true
      },
      component:UserList
    },
    {
      path:'/home/newterminal',
      name:'Home/NewTerminal',
      meta:{
        layout:'default',
        isLogin:true
      },
      component:NewTerminal
    },
    {
      path:'/home/newproduct',
      name:'Home/Newproduct',
      meta:{
        layout:'default',
        isLogin:true
      },
      component:Newproduct
    },
    {
      path:'/home/newbasestation',
      name:'Home/NewBasestation',
      meta:{
        layout:'default',
        isLogin:true
      },
      component:NewBasestation
    },
    {
      path:'/home/newuser',
      name:'Home/NewUser',
      meta:{
        layout:'default',
        isLogin:true
      },
      component:Home
    },
    {
      path:'/home/terminallist',
      name:'Home/TerminalList',
      meta:{
        layout:'default',
        isLogin:true
      },
      component:TerminalList
    },
    {
      path:'/home/versionlist',
      name:'Home/VersionList',
      meta:{
        layout:'default',
        isLogin:true
      },
      component:VersionList
    },
    {
      path:'/home/basestationlist',
      name:'Home/BasestationList',
      meta:{
        layout:'default',
        isLogin:true
      },
      component:BasestationList
    },
    {
      path:'/home/terminalactive',
      name:'Home/TerminalActive',
      meta:{
        layout:'default',
        isLogin:true
      },
      component:TerminalActive
    },
    {
      path:'/home/ldh12active',
      name:'Home/Ldh12active',
      meta:{
        layout:'default',
        isLogin:true
      },
      component:Ldh12active
    },
    {
      path:'/home/qxaccountlist',
      name:'Home/QxaccountList',
      meta:{
        layout:'default',
        isLogin:true
      },
      component:QxaccountList
    },
    {
      path:'/home/qxaccountdetail',
      name:'Home/QxaccountDetail',
      meta:{
        layout:'default',
        isLogin:true
      },
      component:QxaccountDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js